var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { Primary } from '../../constants/color.enum';
import joinClassName from '../../utils/className.utils';
import { getContextColorStyle } from '../../utils/colors.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { isFunction } from '../../utils/typeChecks.utils';
import { FormContext, useCreateFormContextAndResizeQuery } from './Form.context';
var FormForm = function (props) {
    var p = useProps(props);
    var _a = useCreateFormContextAndResizeQuery(p), context = _a.context, ref = _a.ref;
    var s = useStore(function () { return ({
        get form() {
            return p.form;
        },
        handleFocus: function () {
            var _a;
            (_a = context.onFocus) === null || _a === void 0 ? void 0 : _a.call(context);
        },
        handleChange: function () {
            var _a;
            (_a = context.onChange) === null || _a === void 0 ? void 0 : _a.call(context);
        },
        handleBlur: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                (_a = context.onBlur) === null || _a === void 0 ? void 0 : _a.call(context);
                return [2 /*return*/];
            });
        }); },
        handleNativeSubmit: function (e) { return e.preventDefault(); },
        get style() {
            return __assign({}, getContextColorStyle(Primary, p.color));
        }
    }); });
    return React.createElement(Observer, { children: function () {
            var _a, _b, _c, _d;
            return (React.createElement(FormContext.Provider, { value: context },
                React.createElement("form", { className: joinClassName('FormForm', p.className), id: context.id, ref: ref, onFocus: s.handleFocus, onBlur: s.handleBlur, onChange: s.handleChange, onSubmit: s.handleNativeSubmit, style: s.style, "data-display-mode": (_a = context.resizeQuery) === null || _a === void 0 ? void 0 : _a.displayMode, "data-only-phones": (_b = context.resizeQuery) === null || _b === void 0 ? void 0 : _b.onlyPhones, "data-from-tablet": (_c = context.resizeQuery) === null || _c === void 0 ? void 0 : _c.fromTablet, "data-from-desktop": (_d = context.resizeQuery) === null || _d === void 0 ? void 0 : _d.fromDesktop, noValidate: !props.enableBrowserValidation }, isFunction(props.children) ? props.children(context) : props.children)));
        } });
};
export default FormForm;
